import React, { useState } from 'react';
import axios from 'axios';

function EditorGiris() {
    const [blogname, setBlogname] = useState('');
    const [feedback, setFeedback] = useState('');
    const [imageFile, setImageFile] = useState(null); // State for storing selected image file
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false); // New state to track submission status

    const handleFileChange = (event) => {
        setImageFile(event.target.files[0]); // Grab the first file from the event
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (isSubmitting) return; // Prevent multiple submissions if already submitting

        setIsSubmitting(true); // Set submitting state to true

        try {
            const formData = new FormData();
            formData.append('blogname', blogname);
            formData.append('feedback', feedback);
            formData.append('imageFile', imageFile); // Append the image file to FormData

            const response = await axios.post('api/editor', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            console.log(response.data);

            setBlogname('');
            setFeedback('');
            setImageFile(null); // Reset image file state after submission
            setSubmitted(true);

            // Yeniden yönlendirme veya sayfanın yenilenmesi için 2 saniye bekleyin
            setTimeout(() => {
                setSubmitted(false);
                window.location.reload(); // Sayfayı yeniden yükle
            }, 2000);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setIsSubmitting(false); // Reset submitting state after completion
        }
    };

    return (
        <>
            {/* breadcrumb-section */}
            <div className="breadcrumb-section breadcrumb-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <div className="breadcrumb-text">
                                <p>Blog Girişi Yap</p>
                                <h1>Formu</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end breadcrumb section */}

            <div className="contact-from-section mt-150 mb-150">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mb-5 mb-lg-0">
                            <div className="form-title">
                                <h2>Editor Post Girişi </h2>
                                <p>Editör Post</p>
                            </div>
                            <div id="form_status"></div>
                            <div className="contact-form">
                                <form onSubmit={handleSubmit}>
                                    {submitted ? (
                                        <div className="thank-you-message">
                                            <p>Teşekkürler! Blog başarıyla eklenmiştir.</p>
                                        </div>
                                    ) : (
                                        <>
                                            <p>
                                                <input
                                                    type="text"
                                                    value={blogname}
                                                    onChange={(e) => setBlogname(e.target.value)}
                                                    placeholder="Post Başlığı"
                                                    name="blogname"
                                                    id="blogname"
                                                    required
                                                />
                                            </p>
                                            <p>
                                                <textarea
                                                    value={feedback}
                                                    onChange={(e) => setFeedback(e.target.value)}
                                                    name="feedback"
                                                    id="feedback"
                                                    cols="30"
                                                    rows="5"
                                                    placeholder="Alt Metin"
                                                    maxLength="190" // Karakter limiti ekleyin
                                                    required
                                                ></textarea>
                                                <small>{feedback.length}/190</small> {/* Karakter sayacı */}
                                            </p>
                                            <p>
                                                <input
                                                    type="file"
                                                    onChange={handleFileChange}
                                                    accept="image/*"
                                                    required
                                                />
                                            </p>
                                            <p>
                                                <input
                                                    type="submit"
                                                    value={isSubmitting ? "Gönderiliyor..." : "Gönder"} // Change button text
                                                    disabled={isSubmitting} // Disable button if submitting
                                                />
                                            </p>
                                        </>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditorGiris;
